/**
 * Ayuda "Cómo habilitarla" según el sistema del trabajador (006 · US4-2, FR-015).
 *
 * Cuando la cámara está bloqueada, la hoja de ayuda muestra los pasos del sistema y del modo en que
 * se abrió Fermin (instalada o en el navegador), porque el camino a los permisos es distinto en
 * cada caso. Si no se reconoce el sistema, el texto genérico de siempre (`camera.howToBody`).
 *
 * Solo la cámara: la ubicación denegada nunca bloquea la marcación (US4-4), así que no tiene
 * pantalla de ayuda.
 */
import { DevicePlatform } from '@fermin/contracts';

import { detectPlatform, isStandalone } from '../../device/platform';
import { t } from '../../i18n';

export type CameraHelpVariant =
  | 'iosApp'
  | 'iosBrowser'
  | 'androidApp'
  | 'androidBrowser'
  | 'generic';

/** Clave i18n de cada variante. */
export const CAMERA_HELP_KEYS: Record<CameraHelpVariant, string> = {
  iosApp: 'attendance.camera.howToIosApp',
  iosBrowser: 'attendance.camera.howToIosBrowser',
  androidApp: 'attendance.camera.howToAndroidApp',
  androidBrowser: 'attendance.camera.howToAndroidBrowser',
  generic: 'attendance.camera.howToBody',
};

/** Variante de ayuda para una plataforma y un modo de presentación. */
export function cameraHelpVariant(platform: DevicePlatform, standalone: boolean): CameraHelpVariant {
  if (platform === DevicePlatform.enum.ios) {
    return standalone ? 'iosApp' : 'iosBrowser';
  }
  if (platform === DevicePlatform.enum.android) {
    return standalone ? 'androidApp' : 'androidBrowser';
  }
  return 'generic';
}

/** Texto de ayuda para el teléfono actual (o para el entorno indicado, en pruebas). */
export function cameraHelpText(
  platform: DevicePlatform = detectPlatform(),
  standalone: boolean = isStandalone(),
): string {
  return t(CAMERA_HELP_KEYS[cameraHelpVariant(platform, standalone)]);
}
